import { useOutletContext, useParams } from 'react-router-dom'

import { observer } from 'mobx-react'

import { PortalWrapper } from 'modules/core/components/PortalWrapper'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import type { CommonRouteContext } from 'modules/employees/lib/types'
import Header from 'modules/layout/components/Page/Header'
import { castId } from 'modules/time_planning/lib/castId'
import planningVersions, {
  PlanningVersionProvider,
} from 'modules/time_planning/store/collections/planningVersions'
import schedules, { SchedulesProvider } from 'modules/work_schedules/store/collections/schedules'

import Body from './Body'

const Card = observer(() => {
  const { id: employeeIdparam } = useStrictParams<'id'>()
  const { employee: sessionEmployee } = useCurrentSession()
  const { headerTitle } = useOutletContext<CommonRouteContext>()
  const { planningVersionId } = useParams()
  const employeeId = employeeIdparam ?? sessionEmployee.id
  const planningVersion = planningVersions.getPlanningVersion(castId(planningVersionId), employeeId)

  return (
    <>
      <PortalWrapper container={headerTitle}>
        <Header.Title>{i18n.t('time_planning.title')}</Header.Title>
      </PortalWrapper>
      <PlanningVersionProvider collection={planningVersions}>
        <SchedulesProvider collection={schedules}>
          <Body employeeId={employeeId} planningVersion={planningVersion} />
        </SchedulesProvider>
      </PlanningVersionProvider>
    </>
  )
})

export default Card
